/*
 * Copyright (c) 2021.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import history from 'history/browser';
import {query_decode, query_encode} from "../helpers/functions";

history.pushParams = function (params, cleanOld){
    try{
        params = typeof params === 'string' ? query_decode(params) : params;

        let actual = history.location;
        let actualParams = query_decode(actual.search.substr(1));

        if(cleanOld){
            $.each(actualParams, function (actualParamKey, actualParamValue){
                if(typeof params[actualParamKey] === 'undefined'){
                    params[actualParamKey] = '';
                }
            });
        }

        let nextParams = $.extend({}, actualParams, params);

        let next = {
            hash: actual.hash,
            search: '?'+query_encode(nextParams),
            pathname: actual.pathname
        };

        history.push(next);
    }catch (e){
    }
};

export default history;
